import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #faf5fb 0%, #ffffff 40%, #e8faf3 100%)" }}
    >
      <div className="absolute top-20 right-0 w-96 h-96 rounded-full opacity-10" style={{ background: "#7DD4B5", filter: "blur(100px)" }} />
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full opacity-10" style={{ background: "#b46eb6", filter: "blur(80px)" }} />
      <div className="absolute top-1/3 left-1/3 w-64 h-64 rounded-full opacity-5" style={{ background: "#b46eb6", filter: "blur(60px)" }} />

      {/* Run for Rett Logo Silhouette */}
      <img
        src="/runforrett-silhouette.png"
        alt=""
        aria-hidden="true"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] md:w-[700px] lg:w-[800px] opacity-[0.04] pointer-events-none select-none"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center">
        <div className="space-y-6 md:space-y-8 animate-fade-in-up">
          <p className="font-accent text-2xl md:text-3xl" style={{ color: "#7DD4B5" }}>
            Gemeinsam laufen. Gemeinsam Hoffnung schenken.
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight leading-tight" style={{ color: "#1F2937" }}>
            <span className="block" style={{ color: "#b46eb6" }}>Laufen für eine Zukunft</span>
            <span className="block" style={{ color: "#1F2937" }}>ohne Rett-Syndrom</span>
          </h1>

          <p className="text-base md:text-lg leading-relaxed max-w-2xl mx-auto" style={{ color: "#4B5563" }}>
            Der nächste <strong>Run for Rett</strong> kommt bestimmt. Bleibt gespannt.
            <br />
            Mach mit, lauf mit oder unterstütze die Forschung für eine Zukunft ohne Rett-Syndrom.
          </p>

          <div className="flex flex-wrap justify-center gap-4 pt-2">
            <Button
              data-testid="hero-donate-btn"
              onClick={() => scrollTo("#spenden")}
              className="rounded-full px-8 py-6 text-base font-bold shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 bg-[#b46eb6] hover:bg-[#8f5691] text-white"
            >
              Spenden
            </Button>
            <Button
              data-testid="hero-learn-btn"
              onClick={() => scrollTo("#ella")}
              variant="outline"
              className="rounded-full px-8 py-6 text-base font-semibold border-2 border-[#b46eb6]/20 hover:border-[#b46eb6] hover:bg-[#b46eb6]/5 text-[#b46eb6] transition-all"
            >
              Ellas Geschichte
            </Button>
            <Button
              data-testid="hero-info-btn"
              onClick={() => scrollTo("#rett-info")}
              variant="ghost"
              className="rounded-full px-6 py-6 text-base text-[#7DD4B5] hover:bg-[#7DD4B5]/10 font-medium"
            >
              Mehr erfahren
            </Button>
          </div>
        </div>
      </div>

      <button
        data-testid="scroll-down-btn"
        onClick={() => scrollTo("#ella")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce"
      >
        <ChevronDown className="w-8 h-8" style={{ color: "#7DD4B5" }} />
      </button>
    </section>
  );
}
